
import * as __star__ from 'process';

const {

version,
versions,
arch,
platform,
release,
_rawDebug,
moduleLoadList,
binding,
_linkedBinding,
_events,
_eventsCount,
_maxListeners,
domain,
_exiting,
exitCode,
config,
dlopen,
uptime,
_getActiveRequests,
_getActiveHandles,
getActiveResourcesInfo,
reallyExit,
_kill,
loadEnvFile,
cpuUsage,
resourceUsage,
memoryUsage,
constrainedMemory,
kill,
exit,
hrtime,
openStdin,
getuid,
geteuid,
getgid,
getegid,
getgroups,
allowedNodeEnvironmentFlags,
assert,
features,
_fatalException,
setUncaughtExceptionCaptureCallback,
hasUncaughtExceptionCaptureCallback,
emitWarning,
nextTick,
_tickCallback,
sourceMapsEnabled,
setSourceMapsEnabled,
_debugProcess,
_debugEnd,
_startProfilerIdleNotifier,
_stopProfilerIdleNotifier,
stdout,
stdin,
stderr,
abort,
umask,
chdir,
cwd,
initgroups,
setgroups,
setegid,
seteuid,
setgid,
setuid,
env,
title,
argv,
execArgv,
pid,
ppid,
execPath,
debugPort,
argv0,
_preload_modules,
report,
mainModule
} = __star__;

export {
version,
versions,
arch,
platform,
release,
_rawDebug,
moduleLoadList,
binding,
_linkedBinding,
_events,
_eventsCount,
_maxListeners,
domain,
_exiting,
exitCode,
config,
dlopen,
uptime,
_getActiveRequests,
_getActiveHandles,
getActiveResourcesInfo,
reallyExit,
_kill,
loadEnvFile,
cpuUsage,
resourceUsage,
memoryUsage,
constrainedMemory,
kill,
exit,
hrtime,
openStdin,
getuid,
geteuid,
getgid,
getegid,
getgroups,
allowedNodeEnvironmentFlags,
assert,
features,
_fatalException,
setUncaughtExceptionCaptureCallback,
hasUncaughtExceptionCaptureCallback,
emitWarning,
nextTick,
_tickCallback,
sourceMapsEnabled,
setSourceMapsEnabled,
_debugProcess,
_debugEnd,
_startProfilerIdleNotifier,
_stopProfilerIdleNotifier,
stdout,
stdin,
stderr,
abort,
umask,
chdir,
cwd,
initgroups,
setgroups,
setegid,
seteuid,
setgid,
setuid,
env,
title,
argv,
execArgv,
pid,
ppid,
execPath,
debugPort,
argv0,
_preload_modules,
report,
mainModule
};

